/**
 * @fileoverview パスワードリセット失敗画面
 *
 * このファイルでは、パスワードリセットプロセス中にエラーが発生した場合に
 * 表示されるエラーメッセージ画面を定義しています。
 */

/**
 * パスワードリセット失敗画面コンポーネント
 *
 * パスワードリセット処理中に発生したエラーの詳細をユーザーに表示し、
 * 再試行方法やサポート問い合わせ先など、次のステップへの
 * ガイダンスを提供します。URLパラメータからエラー情報を取得して
 * 具体的なエラーメッセージを表示する機能も含まれています。
 *
 * @returns {JSX.Element} パスワードリセット失敗メッセージ画面
 */
import { Stack, Text } from "@mantine/core";

import { useNavigate } from "@/router";
import { Card } from "@/components/card";
import { Button } from "@/components/button";

export default function ResetPasswordSuccessPage() {
  const navigate = useNavigate();

  return (
    <Card title="パスワードリセット">
      <Stack className="gap-10">
        <Text>パスワードの登録に失敗しました。</Text>
        <div className="flex justify-end">
          <Button text="再度試す" onClick={() => navigate("/reset-password")} />
          <Button text="トップページへ戻る" onClick={() => navigate("/")} />
        </div>
      </Stack>
    </Card>
  );
}
